import logger from './logger';
/**
 * SEC-001 — Secure token & profile storage.
 * Tokens are now stored as httpOnly cookies (set by backend).
 * Only user profile (non-sensitive) is kept in localStorage.
 */

const PROFILE_KEY = 'mevia_user_profile';

/* -------- Token helpers (cookie-managed by backend) -------- */
export const getToken = () => {
  // Token is managed via httpOnly cookie — not accessible from JS.
  // Return null; auth is handled automatically by the browser cookie.
  return null;
};

export const setToken = () => {
  // No-op: token is set as httpOnly cookie by the backend login response.
};

export const removeToken = () => {
  // No-op: cookie is cleared via /api/auth/logout endpoint.
};

/* -------- Profile helpers (localStorage, non-sensitive) -------- */
export const getProfile = () => {
  try {
    const data = localStorage.getItem(PROFILE_KEY);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

export const setProfile = (profile) => {
  try {
    localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
  } catch (e) {
    logger.error('Cannot store profile:', e);
  }
};

export const removeProfile = () => {
  try {
    localStorage.removeItem(PROFILE_KEY);
  } catch (e) {
    logger.error('Cannot remove profile:', e);
  }
};

export const clearAuth = () => {
  removeToken();
  removeProfile();
};
